import React, { SetStateAction } from 'react';
import Pagination from '@mui/material/Pagination';

import * as S from './styles';
import './style.css';

interface PaginationCompProps {
	qtdPages: number;
	getActualPage: React.Dispatch<SetStateAction<number>>;
	actualPage: number;
}

export default function PaginationComp({
	qtdPages,
	getActualPage,
	actualPage
}: PaginationCompProps) {
	return (
		<S.container>
			<Pagination
				count={qtdPages}
				page={actualPage} // Define a página inicial selecionada
				onChange={(_, number) => {
					getActualPage(number); // Atualiza a página ao mudar
				}}
				classes={{
					root: 'pagination-root',
					ul: 'pagination-ul'
				}}
			/>
		</S.container>
	);
}
